/* fiveaven, articles du blog (23/10/2026, demandes d'Andy) :
   1. un lien du texte montre un aperçu avec photo ET des produits : produit (marque, nom, prix), catégorie (nom + 3 produits, marques
      maison en premier), article (titre + ses produits) ; au survol sur ordinateur ;
      sur téléphone, le premier appui ouvre l'aperçu en bas de l'écran (il mène au produit), un second appui suit le lien ;
   2. « Ils vont vous intéresser » sur mobile : les articles défilent au doigt, avec les mêmes flèches rondes que le bloc produits. */
(function () {
  var texte = document.querySelectorAll(".fva-texte");
  if (!texte.length && !document.querySelector(".fva-suite")) return;
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var TACTILE = window.matchMedia("(hover: none)").matches;
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };

  /* ---------- 1. aperçu des liens produits ---------- */
  var cache = {}, cible = null, minuterie = null;
  function poignee(a) { // { type, h, url } pour un lien vers un produit, une catégorie ou un article du site
    try {
      var u = new URL(a.getAttribute("href"), location.href); if (u.origin !== location.origin) return null;
      var m = u.pathname.match(/\/products\/([^\/?#]+)/); if (m) return { type: "produit", h: m[1], url: u.pathname };
      m = u.pathname.match(/\/collections\/([^\/?#]+)\/?$/); if (m && m[1] !== "all" && m[1] !== "vendors") return { type: "categorie", h: m[1], url: u.pathname };
      m = u.pathname.match(/\/blogs\/[^\/]+\/([^\/?#]+)/); if (m) return { type: "article", h: m[1], url: u.pathname };
    } catch (e) { /* lien illisible */ }
    return null;
  }
  var json = function (u) { return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };
  var img2 = function (s) { if (!s) return ""; if (s.indexOf("//") === 0) s = "https:" + s; return s + (s.indexOf("?") < 0 ? "?" : "&") + "width=360"; };
  var euros = function (n) { return (+n).toLocaleString("fr-FR", { style: "currency", currency: "EUR" }); };
  // Andy (23/10/2026) : « faut systématiquement proposer des produits » ; les 11 marques maison passent en premier
  var MAISON = ["DEAROHNEUL", "MIDHA", "NOAV", "PESTLO", "DEWDAP", "INFOD", "ELDEEN", "SKYBOTTLE", "DAMTIX", "DEMIFLOR", "DRCEURACLE"];
  var cle = function (v) { return String(v || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); };
  var maison = function (v) { return MAISON.indexOf(cle(v)) >= 0 ? 0 : 1; };
  function fiche(h) { // produit (.js : prix en centimes) -> { url, img, marque, nom, prix }
    var k = "p:" + h;
    if (!cache[k]) cache[k] = json(RACINE + "products/" + encodeURIComponent(h) + ".js").then(function (p) {
      return p && p.available !== false && { url: RACINE + "products/" + p.handle, img: img2(p.featured_image || (p.images && p.images[0])), marque: p.vendor, nom: p.title, prix: euros(p.price / 100) };
    });
    return cache[k];
  }
  var categories = null; // liste publique des catégories (nom, image), lue une fois
  function infos(c) { // -> { img, sur, titre, bas, voir, produits: [...] }
    var k = c.type + ":" + c.h; if (cache[k]) return cache[k];
    if (c.type === "produit") cache[k] = fiche(c.h).then(function (p) {
      return p && { img: p.img, sur: p.marque, titre: p.nom, bas: p.prix, voir: "Voir le produit", produits: [] };
    });
    else if (c.type === "categorie") {
      categories = categories || json(RACINE + "collections.json?limit=250").then(function (d) { return (d && d.collections) || []; });
      cache[k] = Promise.all([categories, json(RACINE + "collections/" + encodeURIComponent(c.h) + "/products.json?limit=24")]).then(function (x) {
        var col = x[0].filter(function (y) { return y.handle === c.h; })[0];
        var ps = ((x[1] && x[1].products) || []).filter(function (p) { return (p.variants || []).some(function (v) { return v.available; }); });
        ps.sort(function (a, b) { return maison(a.vendor) - maison(b.vendor); });
        var produits = ps.slice(0, 3).map(function (p) {
          var v = p.variants.filter(function (y) { return y.available; })[0];
          return { url: RACINE + "products/" + p.handle, img: img2(p.images && p.images[0] && p.images[0].src), marque: p.vendor, nom: p.title, prix: euros(v.price) };
        });
        if (!col && !produits.length) return null;
        return { img: img2(col && col.image && col.image.src), sur: "Catégorie", titre: col ? col.title : c.h.replace(/-/g, " "), bas: "", voir: "Voir toute la catégorie", produits: produits };
      });
    } else cache[k] = fetch(c.url, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; }).then(function (t) {
      var d = new DOMParser().parseFromString(t || "", "text/html"), meta = function (n) { var e = d.querySelector('meta[property="' + n + '"]'); return e ? e.getAttribute("content") : ""; };
      var titre = meta("og:title") || (d.querySelector("h1") || {}).textContent || "";
      if (!titre) return null;
      var vus = {}, hs = [];
      d.querySelectorAll('.fva-produits a[href*="/products/"]').forEach(function (a) { var m = (a.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/); if (m && !vus[m[1]]) { vus[m[1]] = 1; hs.push(m[1]); } });
      return Promise.all(hs.slice(0, 3).map(fiche)).then(function (produits) {
        return { img: img2(meta("og:image:secure_url") || meta("og:image")), sur: "Article", titre: titre.trim(), bas: "", voir: "Lire l’article", produits: produits.filter(Boolean) };
      });
    }).catch(function () { return null; });
    return cache[k];
  }
  var carte = document.createElement("div");
  carte.className = "fvap"; carte.hidden = true; carte.setAttribute("aria-live", "polite");
  document.body.appendChild(carte);
  function placer(a) {
    if (TACTILE) return; // téléphone : en bas de l'écran (CSS)
    var r = a.getBoundingClientRect(), l = Math.min(Math.max(8, r.left), document.documentElement.clientWidth - carte.offsetWidth - 8);
    var haut = r.bottom + 8; if (haut + carte.offsetHeight > window.innerHeight - 8) haut = r.top - carte.offsetHeight - 8; // au-dessus si pas la place
    carte.style.left = Math.round(l + window.scrollX) + "px"; carte.style.top = Math.round(haut + window.scrollY) + "px";
  }
  function montrer(a) {
    var c = poignee(a); if (!c) return;
    cible = a;
    infos(c).then(function (p) {
      if (!p || cible !== a) return;
      carte.className = "fvap fvap--" + c.type;
      carte.innerHTML = '<a class="fvap__tete" href="' + esc(a.href) + '">' + (p.img ? '<span class="fvap__img"><img src="' + esc(p.img) + '" alt="" width="180" height="180"></span>' : "") +
        '<span class="fvap__txt"><span class="fvap__marque">' + esc(p.sur) + '</span><span class="fvap__nom">' + esc(p.titre) + "</span>" +
        (p.bas ? '<span class="fvap__prix">' + esc(p.bas) + "</span>" : "") + '<span class="fvap__voir">' + esc(p.voir) + "</span></span></a>" +
        (p.produits.length ? '<div class="fvap__produits">' + p.produits.map(function (q) {
          return '<a class="fvap__prod" href="' + esc(q.url) + '"><span class="fvap__pimg">' + (q.img ? '<img src="' + esc(q.img) + '" alt="" width="120" height="120" loading="lazy">' : "") + "</span>" +
            '<span class="fvap__pmarque">' + esc(q.marque) + '</span><span class="fvap__pnom">' + esc(q.nom) + '</span><span class="fvap__pprix">' + esc(q.prix) + "</span></a>";
        }).join("") + "</div>" : "");
      if (TACTILE) { var pb = document.getElementById("PBarNextFrameWrapper"); carte.style.bottom = ((pb && pb.offsetHeight) || 0) + 16 + "px"; } // au-dessus de la barre d'aperçu Shopify
      carte.hidden = false; placer(a);
    });
  }
  function cacher() { cible = null; carte.hidden = true; }
  texte.forEach(function (bloc) {
    bloc.querySelectorAll("a[href]").forEach(function (a) {
      if (!poignee(a)) return;
      a.classList.add("fvap-lien");
      if (TACTILE) {
        a.addEventListener("click", function (e) { if (cible === a && !carte.hidden) return; e.preventDefault(); montrer(a); }); // 2e appui : le lien
      } else {
        a.addEventListener("mouseenter", function () { clearTimeout(minuterie); montrer(a); });
        a.addEventListener("mouseleave", function () { minuterie = setTimeout(cacher, 180); });
        a.addEventListener("focus", function () { montrer(a); });
        a.addEventListener("blur", function () { minuterie = setTimeout(cacher, 180); });
      }
    });
  });
  carte.addEventListener("mouseenter", function () { clearTimeout(minuterie); });
  carte.addEventListener("mouseleave", function () { minuterie = setTimeout(cacher, 180); });
  document.addEventListener("click", function (e) { if (!carte.hidden && !carte.contains(e.target) && !(e.target.closest && e.target.closest(".fvap-lien"))) cacher(); });
  window.addEventListener("scroll", function () { if (!TACTILE && !carte.hidden) cacher(); }, { passive: true });

  /* ---------- 2. carrousel des articles suggérés (mobile) ---------- */
  var suite = document.querySelector(".fva-suite .fvb-grille");
  if (suite && suite.children.length > 1) {
    var rail = document.createElement("div"); rail.className = "fva-suite__rail";
    suite.parentNode.insertBefore(rail, suite); rail.appendChild(suite);
    var fl = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3.333 10h13.334M11.667 15l5-5-5-5"/></svg>';
    var fg = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M16.667 10H3.333M8.333 15l-5-5 5-5"/></svg>';
    rail.insertAdjacentHTML("beforeend", '<button type="button" class="fva-fleche fva-fleche--g" data-fva-sens="-1" aria-label="Articles précédents" hidden>' + fg + "</button>" +
      '<button type="button" class="fva-fleche" data-fva-sens="1" aria-label="Articles suivants">' + fl + "</button>");
    var fleches = rail.querySelectorAll("[data-fva-sens]");
    var maj = function () { // flèches au milieu de la photo, masquées en bout de ligne
      var img = suite.querySelector("img"), fin = suite.scrollWidth - suite.clientWidth - 2;
      if (img) fleches.forEach(function (f) { f.style.top = Math.round(img.getBoundingClientRect().top - rail.getBoundingClientRect().top + img.offsetHeight / 2 - 20) + "px"; });
      fleches.forEach(function (f) { f.hidden = +f.getAttribute("data-fva-sens") < 0 ? suite.scrollLeft <= 2 : suite.scrollLeft >= fin; });
    };
    fleches.forEach(function (f) { f.addEventListener("click", function () {
      var c = suite.firstElementChild, pas = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(suite).columnGap || 0) : suite.clientWidth;
      suite.scrollBy({ left: pas * +f.getAttribute("data-fva-sens"), behavior: "smooth" });
    }); });
    suite.addEventListener("scroll", maj, { passive: true }); window.addEventListener("resize", maj);
    window.addEventListener("load", maj); maj();
  }
})();

// 27/10/2026 (Andy : « dans les articles de blog, c'est pas très bien affiché ») : photos de « Les produits de… » recadrées
// sur la silhouette du produit (même calcul que les cases de routine de fv-mon-compte.js), centrées, même taille d'une ligne à l'autre
(function () {
  var imgs = document.querySelectorAll(".fva-pl__image img[data-cadre]");
  if (!imgs.length) return;
  function silhouette(img) {
    if (img._bb !== undefined) return img._bb;
    var bb = null;
    try {
      var c = document.createElement("canvas"); c.width = 96; c.height = Math.max(1, Math.round(96 * img.naturalHeight / img.naturalWidth));
      var x = c.getContext("2d"); x.drawImage(img, 0, 0, c.width, c.height);
      var d = x.getImageData(0, 0, c.width, c.height).data, x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
      for (var j = 0; j < c.height; j++) for (var i = 0; i < c.width; i++) {
        var k = (j * c.width + i) * 4;
        if (d[k + 3] > 24 && (d[k] < 236 || d[k + 1] < 236 || d[k + 2] < 236)) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (j < y0) y0 = j; if (j > y1) y1 = j; }
      }
      if (x1 >= x0 && y1 >= y0) bb = { x0: x0 / c.width, x1: (x1 + 1) / c.width, y0: y0 / c.height, y1: (y1 + 1) / c.height };
    } catch (e) { bb = null; }
    img._bb = bb; return bb;
  }
  function cadrer(img) {
    var z = img.parentNode, b = img.naturalWidth && silhouette(img); if (!z || !b) return; // sans mesure : la photo reste entière (object-fit: contain)
    var cs = getComputedStyle(z), fh = parseFloat(cs.getPropertyValue("--cadre-h")) || 1, fl = parseFloat(cs.getPropertyValue("--cadre-l")) || 1;
    var zw = z.clientWidth, zh = z.clientHeight; if (zw <= 0 || zh <= 0) return;
    var r = img.naturalHeight / img.naturalWidth, bw = b.x1 - b.x0, bh = b.y1 - b.y0;
    var w = Math.min(zw * fl / bw, zh * fh / (bh * r), 4 * zw), h = w * r;
    var left = zw / 2 - (b.x0 + bw / 2) * w, top = zh / 2 - (b.y0 + bh / 2) * h;
    img.style.cssText = "position:absolute;max-width:none;max-height:none;object-fit:fill;width:" + w.toFixed(1) + "px;height:" + h.toFixed(1) + "px;left:" + left.toFixed(1) + "px;top:" + top.toFixed(1) + "px";
  }
  function tout() { imgs.forEach(function (im) { if (im.complete && im.naturalWidth) cadrer(im); else im.addEventListener("load", function () { cadrer(im); }, { once: true }); }); }
  tout();
  var l = window.innerWidth, t = null;
  window.addEventListener("resize", function () { if (window.innerWidth === l) return; l = window.innerWidth; clearTimeout(t); t = setTimeout(tout, 150); });
})();
